<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
        <app-date-picker
          @input="onChangeFilter"
          v-model="filter_start"
          placeholder="Tour start"
          class="datepicker--filter"
        />
        <app-date-picker
          @input="onChangeFilter"
          v-model="filter_end"
          placeholder="Tour finish"
          class="datepicker--filter"
        />
        <app-select
          @input="onChangeCategory"
          v-model="category_filter"
          :options="category_options"
          :reduce="item => item.id"
          :filterable="false"
          :searchable="false"
          placeholder="Category"
          class="select--200"
        />
        <app-filters
          v-model="assigned_filter"
          :filters="assigned_filters"
          name="filterAssigned"
          @change="onChangeFilter"
        />
      </app-cells>
      <div v-for="table_item of clients_table" :key="table_item.name" class="climbing-block">
        <app-cells>
          <h2 class="title">{{ table_item.name }}</h2>
          <div v-if="table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__select>
            <label
              v-if="table.items.length && table.items.some(item => !item.briefing || !item.eq_check)"
              class="checkbox checkbox--table"
            >
              <input
                v-model="checked_all"
                type="checkbox"
                name="checked_all"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #h__climbing_group>
            <div class="table-default__left">Group name</div>
          </template>
          <template #h__full_name>
            <div class="table-default__left">Full name</div>
          </template>
          <template #h__hotel>
            <div class="table-default__left">Hotel</div>
          </template>
          <template #h__group>
            <div class="table-default__left">Group</div>
          </template>
          <template #select="{ row }">
            <label v-if="!row.briefing || !row.eq_check" class="checkbox checkbox--table">
              <input
                v-model="checked"
                type="checkbox"
                :value="row"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #climbing_group="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'climbing-groups-detail-clients', params: { id: row.group.id } }"
                class="table-default__link-border"
              >
                {{ row.group.name }}
              </router-link>
            </div>
          </template>
          <template #route="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.group.type.color }"
              v-tooltip="{ content: row.group.type.name, placement: 'top-start', offset: 10 }"
            >
              {{ row.group.route.name }} {{ row.group.route.duration }}
            </span>

          </template>
          <template #start="{ row }">
            {{ dateFormat(row.group.tour_start)  }}
          </template>
          <template #full_name="{ row }">
            <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
              <router-link
                :to="{ name: 'clients-detail', params: { id: row.client.id } }"
                class="table-default__link-border"
              >
                {{ row.client.full_name }}
              </router-link>
              <span v-if="row.age">({{ row.age }} y.o.)</span>
            </div>
          </template>
          <template #hotel="{ row }">
            <router-link
              v-if="row.before"
              :to="{ name: 'reservation-hotels-general', params: { id: row.before.reservation_id } }"
              class="table-default__link-border"
              target="_blank"
            >
              {{ row.before.hotel_name }} ({{ row.before.room_name }})
            </router-link>
            <template v-else>-</template>
          </template>
          <template #group="{ row }">
            <div class="table-default__left table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              <router-link
                v-if="row.client.group"
                :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
                class="table-default__link-border"
              >
                {{ row.client.group.name }}
              </router-link>
              <div v-else class="table-default__left">-</div>
            </div>
          </template>
          <template #safari="{ row }">
            <div class="table-default__controls">
              <button
                @click="onShowSafariModal(row.client)"
                type="button"
                v-tooltip="{ content: tooltipContentSafari(row.client.safari), placement: 'top-start', offset: 10, html: true }"
                class="table-default__activity table-default__activity--safari"
                :class="{'table-default__activity--active': row.client.safari.length}"
              >
              </button>
            </div>
          </template>
          <template #arrival_method="{ row }">
            <div class="table-default__controls">
              <span
                class="table-default__transport table-default__transport--arrival"
                :class="{
                'table-default__transport--present': row.client.transport.arrival.arrival_method,
                'table-default__transport--confirmed': row.client.transport.arrival.arrival_confirmed,
                'table-default__transport--car': row.client.transport.arrival.arrival_method?.code === 'car',
                'table-default__transport--bus': row.client.transport.arrival.arrival_method?.code === 'bus',
                'table-default__transport--self': row.client.transport.arrival.arrival_method?.code === 'self'
              }"
              ></span>
            </div>
          </template>
          <template #arrival_date="{ row }">
            {{ row.client.transport.arrival.arrival_date ? dateFormat(row.client.transport.arrival.arrival_date) : '-' }}
            {{ row.client.transport.arrival.arrival_time ? row.client.transport.arrival.arrival_time : '' }}
          </template>
          <template #arrival_location="{ row }">
            {{ row.client.transport.arrival.arrival_location ? row.client.transport.arrival.arrival_location.short_name : '-' }}
          </template>
          <template #arrival_notes="{ row }">
            <div class="table-default__controls">
              <div
                v-tooltip="{ content: row.client.transport.arrival.arrival_notes, placement: 'left', offset: 10 }"
                class="table-default__activity table-default__activity--notes"
                :class="{'table-default__activity--active': row.client.transport.arrival.arrival_notes}"
              ></div>
            </div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="50" />
      </app-cells>
    </template>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onShowEventModal">Create briefing</app-button>
      <app-button @click.native="onShowAddClientModal">Add to briefing</app-button>
    </div>
    <modal
      name="safari-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('safari-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/safari-modal-icon.svg" alt="Safari">
          <span>Safari</span>
        </div>
        <div class="popup__body">
          <div class="popup__activities">
            <div
              v-for="activity of safari_modal_data"
              :key="activity.id"
              class="popup__activity"
            >
              <div class="popup__activity-info">
                <div class="popup__activity-row popup__activity-row--single">
                  <div class="popup__activity-values">
                    <span>Group Name:</span>
                    <router-link
                      :to="{name: 'safari-groups-detail', params: {id: activity.id}}"
                      class="popup__activity-link"
                    >
                      {{ activity.name }}
                    </router-link>
                  </div>
                </div>
                <div class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Tour start:</span>
                    <span>{{ dateFormat(activity.tour_start) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Tour finish:</span>
                    <span>{{ dateFormat(activity.tour_end) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Duration:</span>
                    <span>{{ activity.duration }} days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="event-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideEventModal" class="popup__close" type="button"></button>
        <div class="popup__title">{{ !event_to_update ? 'Creating new briefing' : 'Updating briefing' }}</div>
        <div class="popup__body">
          <app-grid>
            <template #item-1>
              <app-form-group>
                <app-cells :indent="false">
                  <app-checkbox
                    v-model="form.briefing"
                    label="Briefing"
                  />
                  <app-checkbox
                    v-model="form.eq_check"
                    label="Equipment check"
                  />
                </app-cells>
              </app-form-group>
              <app-form-group label="Date" required>
                <app-date-picker
                  v-model="form.date"
                  placeholder="Date"
                  :error="$v.form.date.$error"
                />
                <template #error>
                  <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
                </template>
              </app-form-group>
              <app-cells :indent="false" :wrap="false">
                <app-form-group label="Time start" label-for="time_start" required>
                  <app-input
                    v-model="form.time_start"
                    v-mask="'99:99'"
                    placeholder="Time start"
                    autocomplete="off"
                    id="time_start"
                    name="time_start"
                    @paste.native.prevent
                    :error="$v.form.time_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.time_start.$dirty && !$v.form.time_start.required">Required field</div>
                    <div v-if="$v.form.time_start.$dirty && !$v.form.time_start.timeRegex">Wrong time</div>
                  </template>
                </app-form-group>
                <app-form-group label="Time end" label-for="time_end" required>
                  <app-input
                    v-model="form.time_end"
                    v-mask="'99:99'"
                    placeholder="Time end"
                    autocomplete="off"
                    id="time_end"
                    name="time_end"
                    @paste.native.prevent
                    :error="$v.form.time_end.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.time_end.$dirty && !$v.form.time_end.required">Required field</div>
                    <div v-if="$v.form.time_end.$dirty && !$v.form.time_end.timeRegex">Wrong time</div>
                  </template>
                </app-form-group>
              </app-cells>
              <app-form-group label="Location" required>
                <app-select
                  @input="onLocationSelected"
                  @search="onLocationSearch"
                  v-model="form.location"
                  :options="location_options"
                  :clearable="false"
                  placeholder="Location"
                  :error="$v.form.location.$error"
                />
                <template #error>
                  <div v-if="$v.form.location.$dirty && !$v.form.location.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #item-2>
              <app-form-group label="Managers" required>
                <app-select
                  v-model="form.managers"
                  :options="manager_options"
                  :display-field="option => `${option.first_name} ${option.last_name}`"
                  label="first_name"
                  placeholder="Managers"
                  multiple
                  :error="$v.form.managers.$error"
                />
                <template #error>
                  <div v-if="$v.form.managers.$dirty && !$v.form.managers.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group v-if="form.briefing" label="Speech" required>
                <app-select
                  v-model="form.speech"
                  :options="form.managers"
                  :clearable="false"
                  :display-field="option => `${option.first_name} ${option.last_name}`"
                  label="first_name"
                  placeholder="Speech"
                  :error="$v.form.speech.$error"
                />
                <template #error>
                  <div v-if="$v.form.speech.$dirty && !$v.form.speech.required">Required field</div>
                </template>
              </app-form-group>
            </template>
          </app-grid>
          <app-form-group label="Notes" label-for="notes">
            <app-textarea
              v-model="form.notes"
              id="notes"
              placeholder="Notes"
            />
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button
              @click.native="onCheckForm"
              ref="createEvent"
              :disabled="$v.form.$error"
            >
              {{ !event_to_update ? 'Create briefing' : 'Update briefing' }}
            </app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="add-client-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideAddClientModal" class="popup__close" type="button"></button>
        <div class="popup__title">Add clients to exist briefing</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckAddForm">
            <app-form-group label="Briefing" required>
              <app-select
                v-model="add_client_form.briefing"
                :options="briefing_options"
                :clearable="false"
                placeholder="Briefing"
                :error="$v.add_client_form.briefing.$error"
              />
              <template #error>
                <div v-if="$v.add_client_form.briefing.$dirty && !$v.add_client_form.briefing.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="addClient" type="submit">Add</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingBriefings,
  getClimbingClientsForBriefingsByDates,
  getGoogleSearch,
  getUsers,
  postClimbingBriefing,
  postClimbingBriefingClients,
  postLocation,
} from '@/http'
import { format, parse } from 'date-fns'
import debounce from 'lodash/debounce'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClimbingBriefingsClients',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: [
          'select',
          'climbing_group',
          'route',
          'start',
          'full_name',
          'hotel',
          'group',
          'safari',
          'arrival_method',
          'arrival_date',
          'arrival_location',
          'arrival_notes'
        ],
        options: {
          headings: {
            select: '',
            climbing_group: 'Group name',
            route: 'Route',
            start: 'Tour start',
            full_name: 'Full name',
            hotel: 'Hotel',
            group: 'Group',
            safari: 'Safari',
            arrival_method: 'Transport',
            arrival_date: 'Date',
            arrival_location: 'Location',
            arrival_notes: 'Notes',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      clients_table: [],
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      safari_modal_data: [],
      client_hash: '',
      family_url: process.env.VUE_APP_FAMILY,
      category_filter: 'upcoming',
      category_options: [
        {
          id: 'upcoming',
          name: 'Upcoming',
        },
        {
          id: 'past',
          name: 'Past',
        },
      ],
      assigned_filter: 'false',
      assigned_filters: [
        { value: 'false', label: 'Not assigned' },
        { value: 'true', label: 'Assigned' },
        { value: '', label: 'All' }
      ],
      filter_start: null,
      filter_end: null,
      search: '',
      event_to_update: null,
      manager_options: [],
      location_options: [],
      form: {
        briefing: true,
        eq_check: true,
      },
      add_client_form: {},
      table_preloader: false,
      table_length: null,
      briefing_options: [],
    }
  },
  validations: {
    form: {
      speech: {
        required: requiredIf(function() {
          return this.form.briefing
        })
      },
      time_start: { timeRegex, required },
      time_end: { timeRegex, required },
      managers: { required },
      date: { required },
      location: { required },
      clients: { required },
    },
    add_client_form: {
      briefing: { required },
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if (!this.checked.includes(item.client.id) && (!item.briefing || !item.equipment_check)) this.checked.push(item)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    this.fetchItems()
    getUsers({ group: 'operations_manager,general_manager,operations_supervisor', is_active: true, is_superuser: false }).then(response => { this.manager_options = response.data })
    getClimbingBriefings({ category: 'upcoming' }).then(response => { this.briefing_options = response.data })
  },
  methods: {
    onShowAddClientModal() {
      this.add_client_form.clients = [...this.checked]
      this.$modal.show('add-client-modal')
    },
    onHideAddClientModal() {
      this.$modal.hide('add-client-modal')
    },
    onCheckAddForm() {
      this.$v.add_client_form.$touch()
      if (this.$v.add_client_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddForm()
      }
    },
    sendAddForm() {
      this.$refs.addClient.preload = true
      const data = this.add_client_form.clients.map(item => ({client: item.id, climbing_group: item.group.id}))
      postClimbingBriefingClients(this.add_client_form.briefing.id, data)
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Client added',
          })
          this.onHideAddClientModal()
          this.add_client_form = {}
          this.$v.add_client_form.$reset()
          this.checked = []
        })
        .catch(() => {
          this.$refs.addClient.preload = false
        })
    },
    fetchItems() {
      getClimbingClientsForBriefingsByDates({
        page: this.pagination.page,
        page_size: 50,
        search: this.search,
        category: this.search ? '' : this.category_filter,
        tour_start: this.search ? '' : this.filter_start,
        tour_end: this.search ? '' : this.filter_end,
        group_by: 'group__tour_start',
        range_type: 'day',
        assigned: this.assigned_filter === '' ? '' : this.assigned_filter === 'true'
      })
        .then(response => {
          this.clients_table = response.data.results.length ? response.data.results : [{name: '', items: []}]
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.table_length = 0
          response.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.table_preloader = false
          this.is_loaded = true
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    tooltipContent(data, type) {
      let managers = ''
      data[type].managers.forEach(item => {
        managers += `${item.full_name}, `
      })
      managers = managers.slice(0, -2)
      if (type === 'briefing') return `${this.dateFormat(data.briefing.date)} ${data.briefing.time_start} - ${data.briefing.time_end}<br>Managers: ${managers}<br>${data.briefing.location.short_name}`
      return `${this.dateFormat(data.eq_check.date)} ${data.eq_check.time_start} - ${data.eq_check.time_end}<br>Managers: ${managers}<br>${data.eq_check.location.short_name}`
    },
    tooltipContentSafari(data) {
      let result = ''
      data.forEach(item => {
        result += `${item.name} (${this.dateFormat(item.tour_start)} - ${this.dateFormat(item.tour_end)})<br>`
      })
      return result
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onShowSafariModal(data) {
      if (!data.safari.length) return
      this.safari_modal_data = data.safari
      this.client_hash = data.hash
      this.$modal.show('safari-modal')
    },
    onShowEventModal() {
      this.form.clients = this.checked
      this.$modal.show('event-modal')
    },
    onHideEventModal() {
      this.$modal.hide('event-modal')
      this.form = {
        briefing: true,
        eq_check: true
      }
      this.$v.form.$reset()
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.createEvent.preload = true
      postClimbingBriefing(this.normalizeForm())
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Briefing created',
          })
          this.onHideEventModal()
          this.checked = []
        })
        .catch(() => {
          this.$refs.createEvent.preload = false
        })
      // if (!this.event_to_update) {
      //
      // } else {
      //   patchClimbingGroupsEvent(this.$route.params.id, this.event_to_update, this.normalizeForm())
      //     .then(() => {
      //       this.fetchEvents()
      //       this.fetchClients()
      //       this.$notify({
      //         type: 'success',
      //         title: 'Event updated',
      //       })
      //       this.onHideEventModal()
      //     })
      //     .catch(() => {
      //       this.$refs.createEvent.preload = false
      //     })
      // }
    },
    normalizeForm() {
      const form = {...this.form}
      form.clients = form.clients.map(item => item.id)
      form.location = form.location.id
      form.managers = form.managers.map(item => item.id)
      if (!form.briefing) form.speech = null
      else form.speech = form.speech.id
      return form
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.search = ''
      this.fetchItems()
    },
    onChangeCategory() {
      this.pagination.page = 1
      this.search = ''
      this.fetchItems()
    },
    onGroupsSearch() {
      this.searchGroups(this)
    },
    onLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form.location = res.data
      })
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.climbing-block
  margin-bottom: 30px
</style>
